/**
 * @file ContractOrdersModal.js
 * @version 1.1.0
 * @author Cam Seymour
 * @project Excel Agri System
 * @created 2026-10-28
 * @modified 2026-10-28
 * @description A contract row's "Add orders…" (Cam, 28 Oct 2026): the orders
 *              counted against it (ContractOrdersPanel), with the Add orders
 *              window open straight away for someone who may edit contract
 *              pricing. Closing it tells the screen behind, whose ordered /
 *              remaining figures may have moved.
 */

import React from 'react';
import Modal from './Modal';
import ContractOrdersPanel from './ContractOrdersPanel';
import useAccess from '../hooks/useAccess';
import { useSlideOutButton } from './SlideOutButton';
import './ContractOrdersPanel.css';

function ContractOrdersModal({ set, title, onClose, editPermissions = ['contract_pricing.edit'] }) {
  const access = useAccess();
  // A milk powder price may also be changed with 'Edit milk powder pricing' (28 Oct 2026).
  const canEdit = editPermissions.some(k => access.canWrite(k));
  useSlideOutButton([set ? 1 : 0]);
  if (!set) return null;
  return (
    <Modal
      isOpen
      onClose={onClose}
      title={title || 'Orders on this contract'}
      size="xl"
      className="contract-orders-modal"
      footer={(
        <div className="buttons slideout">
          <div>
            <button type="button" className="btn-slideout" onClick={onClose}>
              <div className="icon-wrapper"><span className="material-symbols-rounded">close</span></div>
              <span className="btn-label">Close</span>
            </button>
          </div>
        </div>
      )}
    >
      <ContractOrdersPanel
        set={set}
        editPermissions={editPermissions}
        startAdding={canEdit}
        title={set.kind === 'milk_powder' ? 'Orders priced from these milk powder prices' : 'Orders counted against this contract'}
      />
    </Modal>
  );
}

export default ContractOrdersModal;
